import { apps, auth, initializeApp } from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { UserType } from "@/types";
import { firebase as config } from "@/config";

export type InitializeCallback = (
  user: UserType | null,
  credential?: auth.AuthCredential | null
) => void;

export default class AuthApi {
  initialize(callback: InitializeCallback) {
    if (!apps.length) initializeApp(config);
    auth().onAuthStateChanged((user) => callback(user));
    auth()
      .getRedirectResult()
      .then(({ user, credential }) => callback(user, credential))
      .catch(window.console.warn);
  }

  signInAnonymous() {
    return auth().signInAnonymously();
  }

  signInGoogle() {
    return auth().signInWithRedirect(new auth.GoogleAuthProvider());
  }

  signOut() {
    return auth().signOut();
  }
}
